import React, { useEffect, useRef } from "react";
import { renderAsync } from "docx-preview";

export default function DocxViewer({ blob }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!blob || !containerRef.current) return;

    containerRef.current.innerHTML = "";

    renderAsync(blob, containerRef.current, null, {
      className: "docx", // important pour le style
      inWrapper: true,
      ignoreWidth: true,
      ignoreHeight: true,
      ignoreFonts: false,
      breakPages: true // pagination
    });
  }, [blob]);

  return (
    <div
      style={{
        overflow: "auto"
      }}
    >
      <div
        ref={containerRef}
        style={{
          background: "white",
          margin: "none",
        }}
      />
    </div>
  );
}